import type { ReactNode } from 'react'

/**
 * The header's box: the sticky bar, its border and its 56px row (57px in
 * all, which src/index.css names --site-header-h for whatever pins under it;
 * change one, change the other).
 *
 * Shared by Header (which fills it) and the build-time prerender's
 * StaticFrame (which renders it EMPTY above a page's static markup). The
 * prerendered page therefore sits exactly where the mounted page will, and
 * only the header's contents pop in when the SPA mounts. Change the box here
 * and both move together.
 *
 * Must stay free of browser globals and router hooks: the prerender renders
 * it in Node with no router.
 */
export default function HeaderShell({ children }: { children?: ReactNode }) {
  return (
    <header className="border-b border-gray-800 bg-gray-950 sticky top-0 z-50">
      {/* Matches --container-report, the widest page content on the site. */}
      <div className="max-w-report mx-auto px-4 h-14 flex items-center justify-between">
        {children}
      </div>
    </header>
  )
}
